"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogBody,
} from "../../ui/dialog";
import Button from "../../button-v1";

export default function ResetCareplan({
  isOpen,
  setIsOpen,
  onReset,
}) {
  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleReset = () => {
    onReset?.();
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reset Care Plan</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <p style={{textAlign: "center"}}>
            Restarting will delete all data for this care plan.
            <br />
            Are you sure you want to proceed?
          </p>
        </DialogBody>

        <DialogFooter>
          <Button variant="ghost" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleReset}>
            Restart
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
